export default "__VITE_ASSET__c949e1c7__"